import React from "react";
import ReactDOM from "react-dom";
import Main from "./containers/Main";
import "./App.css";

ReactDOM.render(<Main />, document.getElementById("root"));
